import createLucideIcon from '../createLucideIcon';

const AlignLeft = createLucideIcon('AlignLeft', [
  ['line', { x1: '21', y1: '6', x2: '3', y2: '6', key: '1e448z' }],
  ['line', { x1: '15', y1: '12', x2: '3', y2: '12', key: '80e4vw' }],
  ['line', { x1: '17', y1: '18', x2: '3', y2: '18', key: '1771gn' }],
]);

export default AlignLeft;
